export enum ELocationAttributeId {
  NOMINATABLE = 99010,
  RELEASEABLE = 99012,
  MASTER_LIST = 99016,
}

export enum EPipelineSystemCode {
  PETAL_STORAGE = 'PST',
}
